import ProtectedContent from "../components/ProtectedContent"


export default function StoryAccess({ data, watermark }) {
  return (
    <ProtectedContent watermark={watermark}>
      <div className="library-story-access">
        {
          data.contents && data.contents.length > 0 ?
            data.contents.map((content, index) => {
              return (
                <article className="card library-story-part" key={content.uuid}>
                  <div className="card-body">
                    <span className="marketplace-eyebrow text-primary">PART {index + 1}</span>
                    <h6>{content.title}</h6>
                    <div
                      className="marketplace-rich-content"
                      dangerouslySetInnerHTML={{ __html: content.body }}
                    >
                    </div>
                  </div>
                </article>
              )
            })
            :
            <div className="marketplace-empty-state">No published story content was found.</div>
        }
      </div>
    </ProtectedContent>
  )
}
